"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerSalutation = exports.getSalutationText = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const flora_react_1 = require("@grupoboticario/flora-react");
const react_1 = require("react");
const useCustomer_1 = require("../../../../hooks/useCustomer");
const customer_1 = require("../../../../utils/helpers/customer");
const CustomerAvatar_1 = require("../../icons/CustomerAvatar");
const getSalutationText = (name) => (name ? `Olá, ${name}!` : 'Olá!');
exports.getSalutationText = getSalutationText;
const CustomerSalutation = () => {
    const { isLogged } = (0, useCustomer_1.useCustomer)();
    const [userInfo, setUserInfo] = (0, react_1.useState)({ givenName: '', profileImage: '' });
    (0, react_1.useEffect)(() => {
        const { givenName = '', profileImage = '' } = (0, customer_1.getCustomerInfoFromJwt)();
        setUserInfo({ givenName, profileImage });
    }, [isLogged]);
    return ((0, jsx_runtime_1.jsxs)(flora_react_1.Flex, Object.assign({ align: "center", css: { paddingLeft: '$4' } }, { children: [userInfo.profileImage ? ((0, jsx_runtime_1.jsx)(flora_react_1.Image, { css: {
                    width: 36,
                    height: 36,
                    borderRadius: '50%',
                    border: '1px solid $backgroundAltPrimary',
                }, alt: "Imagem de perfil", size: "$7", src: userInfo.profileImage })) : ((0, jsx_runtime_1.jsx)(CustomerAvatar_1.CustomerAvatar, {})), (0, jsx_runtime_1.jsx)(flora_react_1.Text, Object.assign({ size: "bodyLargeStandardRegular", css: { marginLeft: '$4' } }, { children: (0, exports.getSalutationText)(userInfo.givenName) }))] })));
};
exports.CustomerSalutation = CustomerSalutation;
